import React, { useState } from 'react';
import ReferenceFileList from './ReferenceFileList';

import { IFile } from '@routes/Common/type';

import Loading from '@components/Loading';
import { useSnackbar, clsx } from '@components/Provider';
import { CustomizedTypography, CustomizedButton } from '@components/Customized';

import { RfqDetailData } from '@routes/Common/type';
import { Box, makeStyles, Theme } from '@material-ui/core';

import { useStylesCommon } from './useStyles';
import useFiles from '@hooks/useFiles';

import { Download } from '@carbon/icons-react';

const useStyles = makeStyles<Theme, { matches?: boolean }>((theme) => {
  return {
    root: {
      marginBottom: 0
    },
    boxTitle: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      marginBottom: 16,
      '& svg': {
        fontSize: '20px !important'
      }
    }
  };
});

interface Props {
  data?: RfqDetailData;
  matches?: boolean;
}

const RfqReferenceFilesPresenter: React.FC<Props> = ({ data, matches }) => {
  const classes = useStyles({ matches: matches });
  const classesCommon = useStylesCommon({ matches: matches });
  const { enqueueSnackbar } = useSnackbar();
  const { onDownloadZipFile } = useFiles();
  const [isLoading, setIsLoading] = useState(false);
  const files = data?.referenceFiles ?? [];

  const onFileDownloadAll = () => {
    if (files.length < 1) return false;

    const fileArr: Array<IFile> = [];
    setIsLoading(true);

    files.map((file) => {
      if (file.fileId && file.fileName) {
        fileArr.push({ fileId: file.fileId, fileName: file.fileName });
      }
      return null;
    });

    if (fileArr.length > 1) {
      onDownloadZipFile(fileArr)
        .then(() => {
          setIsLoading(false);
        })
        .catch(() => {
          setIsLoading(false);
          enqueueSnackbar(`파일 다운로드에 실패했습니다.`, {
            variant: 'error'
          });
        });
    }
  };

  return (
    <React.Fragment>
      <Loading open={isLoading} />
      <Box className={clsx(classesCommon.root, classes.root, 'item')}>
        <div className={classes.boxTitle}>
          <CustomizedTypography
            variant={'h4'}
            color="textPrimary"
            fontWeight="500"
          >
            참고파일
          </CustomizedTypography>
          {files.length > 0 && (
            <CustomizedButton
              variant="text"
              size="large"
              startIcon={<Download />}
              onClick={() => {
                onFileDownloadAll();
              }}
            >
              전체 다운로드
            </CustomizedButton>
          )}
        </div>

        {files && files.length > 0 ? (
          <ReferenceFileList files={files} rfqId={data?.id} />
        ) : (
          <CustomizedTypography variant={'body1'} color="textSecondary">
            첨부파일이 없어요.
          </CustomizedTypography>
        )}
      </Box>
    </React.Fragment>
  );
};

export default RfqReferenceFilesPresenter;
